import { call, takeLatest } from "redux-saga/effects";
import { MINMAX_STORE_LIST, MINMAX_GET, MINMAX_ADD, MINMAX_DELETE } from "../types";
import { minMaxGetStoreListApi, minMaxGetApi, minMaxAddMinAndMaxForItemApi, minMaxDeleteMinAndMaxForItemApi } from "../apis/minMax-api";

export function* minMaxGetStoreListWorker(action) {
  try {
    const res = yield call(minMaxGetStoreListApi);
    if (res?.data?.code === 200 || res?.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response || error);
  }
}

export function* minMaxGetWorker(action) {
  try {
    const res = yield call(minMaxGetApi,action.data);
    if (res?.data?.code === 200 || res?.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response || error);
  }
}

export function* minMaxAddWorker(action) {
  try {
    const res = yield call(minMaxAddMinAndMaxForItemApi, action.data);
    if (res?.data?.code === 200 || res?.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response || error);
  }
}

export default function* minMaxSaga() {
  yield takeLatest(MINMAX_STORE_LIST, minMaxGetStoreListWorker);
  yield takeLatest(MINMAX_GET, minMaxGetWorker);
  yield takeLatest(MINMAX_ADD, minMaxAddWorker);
  yield takeLatest(MINMAX_DELETE, function* (action) {
    try {
      const res = yield call(minMaxDeleteMinAndMaxForItemApi, action.data);
      if (res?.data?.code === 200 || res?.status === 200) {
        yield action.onSuccess(res.data);
      } else {
        yield action.onError(res?.data);
      }
    } catch (error) {
      yield action.onError(error?.response || error);
    }
  });
}


